// Create a timestamp to track when the last redirect happened
let lastRedirectTime = 0;
const REDIRECT_COOLDOWN = 2000; // 2 seconds cooldown between redirects

export const authenticatedFetch = (navigate, url, options = {}) => {
  const token = localStorage.getItem("authToken");
  const currentTime = Date.now();

  // Check if we're already in the process of redirecting to login
  // or if a redirect happened recently (within the cooldown period)
  if (window.isRedirectingToLogin || (currentTime - lastRedirectTime < REDIRECT_COOLDOWN)) {
    return new Promise((resolve) => {
      // Return a mock response that will be ignored
      resolve({
        ok: false,
        status: 401,
        json: () => Promise.resolve({ detail: "Authentication required" })
      });
    });
  }

  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    },
  }).then((response) => {
    if (response.status === 401) {
      // Only proceed with redirect if we haven't redirected recently
      if (currentTime - lastRedirectTime >= REDIRECT_COOLDOWN) {
        // Store the current location before redirecting
        const currentPath = window.location.pathname + window.location.search;
        localStorage.setItem("redirectAfterLogin", currentPath);

        // Clear the token
        localStorage.removeItem("authToken");

        // Set flag to prevent multiple redirects
        window.isRedirectingToLogin = true;

        // Update the last redirect time
        lastRedirectTime = currentTime;

        // Show only one alert
        alert("You need to log in to continue. You'll be redirected to the login page.");

        // Navigate to login
        navigate("/login");
      }
    }
    return response;
  });
};
